"use strict";

// Only immutable, published promotion derivatives can enter the image cache.
// This is shared by preload generation, the browser and the HTTP handler.
const SOURCE_PATH = /^\/media\/(img_[a-zA-Z0-9_-]+)\/v([1-9][0-9]*)\/(mobile|desktop)\/(promo_(?:mobile_1080x1350|desktop_1600x720))\.webp$/;
const ROUTE = /^\/static\/promotion-responsive\/v1\/(img_[a-zA-Z0-9_-]+)\/v([1-9][0-9]*)\/(mobile|desktop)\/(promo_(?:mobile_1080x1350|desktop_1600x720))\/(480|768|1080|1024|1600)\.avif$/;
const HOSTS = new Set(["media.ecotourodisha.com", ...["v2", "v3"].flatMap(version =>
  [`kindspear-mr-suite${version}.sgp1.digitaloceanspaces.com`, `kindspear-mr-suite${version}.sgp1.cdn.digitaloceanspaces.com`])]);
const widthsFor = role => role === "mobile" ? [480, 768, 1080] : [1024, 1600];

function promotionCandidates(source) {
  try {
    const url = new URL(source);
    if (url.protocol !== "https:" || !HOSTS.has(url.hostname) || url.port || url.search || url.hash || url.username || url.password) return [];
    const match = url.pathname.match(SOURCE_PATH);
    if (!match) return [];
    const [, image, version, role, preset] = match;
    if ((role === "mobile") !== preset.startsWith("promo_mobile_")) return [];
    return widthsFor(role).map(width => ({ width, url: `/static/promotion-responsive/v1/${image}/v${version}/${role}/${preset}/${width}.avif` }));
  } catch { return []; }
}

function parsePromotionRequest(pathname) {
  const match = pathname.match(ROUTE);
  if (!match) return null;
  const [, image, version, role, preset, size] = match;
  const width = Number(size);
  if (!widthsFor(role).includes(width) || (role === "mobile") !== preset.startsWith("promo_mobile_")) return null;
  return { source: `https://media.ecotourodisha.com/media/${image}/v${version}/${role}/${preset}.webp`, width, quality: role === "mobile" ? 45 : 55 };
}

module.exports = { promotionCandidates, parsePromotionRequest };
